__turbopack_context__.v({
  "buttons": "scene-thumbnail-module__vdJkgG__buttons",
  "card": "scene-thumbnail-module__vdJkgG__card",
  "desc": "scene-thumbnail-module__vdJkgG__desc",
  "editIcon": "scene-thumbnail-module__vdJkgG__editIcon",
  "editInfoIcon": "scene-thumbnail-module__vdJkgG__editInfoIcon",
  "icon": "scene-thumbnail-module__vdJkgG__icon",
  "imageContainer": "scene-thumbnail-module__vdJkgG__imageContainer",
  "metaBody": "scene-thumbnail-module__vdJkgG__metaBody",
  "overlay": "scene-thumbnail-module__vdJkgG__overlay",
  "sceneName": "scene-thumbnail-module__vdJkgG__sceneName",
  "sceneNameContainer": "scene-thumbnail-module__vdJkgG__sceneNameContainer",
  "sceneNameTopPart": "scene-thumbnail-module__vdJkgG__sceneNameTopPart",
  "scenePreviewImage": "scene-thumbnail-module__vdJkgG__scenePreviewImage",
});
